import React from "react"
import styled from "styled-components"
import {css} from "../styles/GlobalStyles"

const fontSizes = {
  full: "0.7rem",
  small: "0.5rem",
}

const StyledFooter = styled.footer`
  width: var(--layout-width);
  color: var(--gray-text);
  padding-bottom: 2px;

  font-size: ${fontSizes.full};
  line-height: ${fontSizes.full};
  font-style: italic;

  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;

  user-select: none;

  @media (min-width: ${css.breakpoints.narrow}) and (max-width: ${css.breakpoints.wide}) {
    font-size: ${fontSizes.small};
    line-height: ${fontSizes.small};
  }
`

type Props = {
  children: JSX.Element | JSX.Element[]
}

const Footer = ({children}: Props) => {
  return (
    <StyledFooter>
      {children}
    </StyledFooter>
  )
}

export default Footer